import EXAMPLE from "../../assets/images/example.png";
import React, { Component } from "react";
import Swal from "sweetalert2";
import Switch from "react-switch";
import Navbar from "../../components/Navbar.js";
import { Modal, Toast } from "react-bootstrap";
import {
  alert,
  format_date,
  GET,
  POST,
  PUT,
  loading,
  BtnIcon,
  project,
  toFixed
} from "../../components/CustomComponent.js";
import Pagination from "@mui/material/Pagination";
import Resizer from "react-image-file-resizer";

import {
  report_categorized_report
} from "../../components/Report.js";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
export default class Customer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      type: "",

      data: [],
      data_expenses: [],
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    try {
      const { year, month, type } = this.state;
      if (month && !year) {
        alert("", "warning", "แจ้งเตือน", "กรุณาเลือกปี");
        return;
      }
      loading(true);
      let data = [],
        count,
        data_expenses;
      let [result_cash_flow, result_petty_cash, result_expenses] =
        await Promise.all([
          GET("api/admin/setting-cash-flow-report/list", {
            year: year || new Date().getFullYear(),
            month: month,
          }),
          GET("api/admin/petty-cash-report/list", {
            year: year || new Date().getFullYear(),
            month: month,
          }),
          GET("api/admin/expense-types-centers/list", {
            page: 0,
            page_size: 1000,
          }),
        ]);
      let data_cash_flow = result_cash_flow.data;
      let data_petty_cash = result_petty_cash.data;
      // data_cash_flow
      const keys = [
        "bank_deposit_balance",
        "cash_deposit_balance",
        "deduction_amount",
        "expense_amount",
        "income_received",
        "other_income",
        "outstanding_debt",
        "prev_balance_bank",
        "prev_balance_cash",
      ];

      const getLastDay = (y, m) => new Date(y, m + 1, 0).getDate();

      const _data1 = (data_cash_flow || []).flatMap((item) => {
        const date = `${item?.year}-${item?.month}-${getLastDay(item?.year, item?.month)}`;

        return keys.flatMap((key) => {
          const rows = item?.[key]?.data || [];

          const itemLevel = rows
            .filter((e) => e?.expenses_type_center)
            .map((e) => ({
              date,
              title: e?.title?.map((t) => t?.value).join(" ") || "-",
              expenses_type_center: e?.expenses_type_center || 0,
              amount: Number(e?.amount || 0),
              image: e?.image || "",
            }));

          // เช็ค (List): expenses_type_center/amount อยู่ใน sub-list ของ title แต่ละตัว
          const listLevel = rows.flatMap((e) => {
            const listEntry = e?.title?.find((t) => t?.type === "list");
            if (!listEntry?.list?.length) return [];

            const baseTitle = e?.title
              ?.filter((t) => t?.type !== "list")
              .map((t) => t?.value)
              .join(" ");

            return listEntry.list
              .filter((sub) => sub?.expenses_type_center)
              .map((sub) => ({
                date,
                title: [baseTitle, sub?.value].filter(Boolean).join(" ") || "-",
                expenses_type_center: sub?.expenses_type_center || 0,
                amount: Number(sub?.amount || 0),
                image: e?.image || "",
              }));
          });

          return [...itemLevel, ...listLevel];
        });
      });

      // data_petty_cash
      const _data2 = (data_petty_cash || []).flatMap((item) =>
        Array.from({ length: 6 }, (_, i) => i + 1).flatMap((i) => {
          const center = item?.[`expenses_type_center_${i}`];
          if (!center) return [];

          return (item?.list_cash_spend || []).map((cash) => ({
            date: cash?.date || "",
            title: item?.["expenses_type_label_"+ (i+1)] || "",
            expenses_type_center: center,
            amount: Number(cash?.amount?.[i - 1]?.amount || 0),
            image: cash?.image_slip || [],
          }));
        }),
      );

      data = [..._data1, ..._data2];
      data = data.filter((e) => !type || e.expenses_type_center === type);

      if (result_expenses?.status) {
        data_expenses = result_expenses.data;
      }
      this.setState({ data, count, data_expenses });
      loading(false);
    } catch (e) {
      console.error(e);
    }
  };

ExportExcel = async () => {
  const array_month = [
    "มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน",
    "กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"
  ];

  const { data, data_expenses, year, month } = this.state;

  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Summary");

  let rowIndex = 1;

  const currentYear = (year || new Date().getFullYear()) + 543;
  const currentMonth = month
    ? array_month[month - 1]
    : array_month[new Date().getMonth()];

  const yearRange = month
    ? `${array_month[month - 1]} ${currentYear} - ${array_month[month - 1]} ${currentYear}`
    : `${array_month[0]} ${currentYear} - ${array_month[11]} ${currentYear}`;

  // ===== HEADER =====
  const addHeader = (text) => {
    // 1. ชี้ไปที่ช่องแรกของแถว (Column 1)
    const cell = ws.getCell(rowIndex, 1);
    
    // 2. ใส่ข้อความและจัด Format ให้เรียบร้อยก่อน
    cell.value = text;
    cell.font = { bold: true, size: 16 };
    cell.alignment = {
      horizontal: "center", // จัดกลางแนวนอน
      vertical: "middle",   // จัดกลางแนวตั้ง
    };

    // 3. ทำการ Merge Cells (แถวปัจจุบัน จากคอลัมน์ 1 ถึง 5)
    ws.mergeCells(rowIndex, 1, rowIndex, 5);

    // 4. ตั้งค่าความสูงของแถว
    ws.getRow(rowIndex).height = 25;

    rowIndex++;
  };

  addHeader("รายงานแยกประเภทค่าใช้จ่าย");
  addHeader(project?.project_name || "");
  addHeader(`ประจำเดือน ${currentMonth} ${currentYear}`);
  addHeader(`ประจำปี ณ เดือน ${yearRange}`);

  rowIndex++; // เว้นบรรทัด

  // ===== TABLE HEADER =====
  ws.addRow([
    "ณ สิ้นสุดวันที่",
    "รายการ",
    "แยกประเภท",
    "ยอดเงิน",
    "link รูปภาพ",
  ]);

  const headerRow = ws.lastRow; // ✅ สำคัญ
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF198754" },
    };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // ===== DATA =====
  (data || []).forEach((item) => {
    const typeName =
      data_expenses?.find(
        (e) => e.expense_type_id === item.expenses_type_center
      )?.expense_type_name || "-";

    ws.addRow([
      format_date(item?.date) || "-",
      item?.title || "-",
      typeName,
      Number(item?.amount || 0),
      Array.isArray(item?.image)
        ? item.image.join(", ")
        : item?.image || "-",
    ]);
  });

  // ===== FORMAT =====
  ws.getColumn(4).numFmt = "#,##0.00";
  ws.getColumn(4).alignment = { horizontal: "right" };

  // auto width
  ws.columns.forEach((col) => {
    let maxLength = 10;
    col.eachCell({ includeEmpty: true }, (cell) => {
      const val = cell.value ? cell.value.toString() : "";
      maxLength = Math.max(maxLength, val.length);
    });
    col.width = maxLength + 2;
  });

  // ===== EXPORT =====
  const buffer = await wb.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "summary.xlsx");
};

  ExportPDF = async () => {
    const { data, data_expenses, year, month } = this.state;
      report_categorized_report(data, data_expenses, year, month);
  };
  render() {
    const { data, data_expenses, month, year, type } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar
          header="Transaction History"
          page1="หน้าหลัก"
          page2="รายงานแยกประเภท"
        />
        <div className="body px-3 pb-3 pt-0">
          <h4 className="fw-bold mb-2">รายงานแยกประเภท</h4>
          <div className="d-flex justify-content-between flex-wrap">
          <div className="d-flex align-items-center flex-wrap mb-3">
            <select
              className="form-control wpx-150 rounded me-2 mb-2"
              onChange={(e) => {
                this.setState({ month: e.target.value });
              }}
              value={month}
            >
              <option value="">เดือน</option>
              {[
                "มกราคม",
                "กุมภาพันธ์",
                "มีนาคม",
                "เมษายน",
                "พฤษภาคม",
                "มิถุนายน",
                "กรกฎาคม",
                "สิงหาคม",
                "กันยายน",
                "ตุลาคม",
                "พฤศจิกายน",
                "ธันวาคม",
              ].map((e, index) => (
                <option value={index + 1}>{e}</option>
              ))}
            </select>
            <select
              className="form-control wpx-150 rounded me-2 mb-2"
              onChange={(e) => {
                this.setState({ year: e.target.value });
              }}
              value={year}
            >
              <option value="">ปี</option>
              {[1, 0, -1, -2, -3, -4, -5, -6, -7, -8, -9, -10].map(
                (e, index) => (
                  <option value={new Date().getFullYear() + e}>
                    {new Date().getFullYear() + e + 543}
                  </option>
                ),
              )}
            </select>
            <select
              className="form-control wpx-250 rounded me-2 mb-2"
              onChange={(e) => {
                this.setState({ type: e.target.value });
              }}
              value={type}
            >
              <option value="">ประเภทค่าใช้จ่ายกลาง</option>
              {data_expenses?.map((e, index) => (
                <option value={e.expense_type_id}>{e.expense_type_name}</option>
              ))}
            </select>
            <div className="d-flex">
              <button
                className="btn btn-success px-4 me-2 mb-2"
                onClick={() => {
                  this.Get(1);
                }}
              >
                ค้นหา
              </button>
              <button
                className="btn btn-outline-success px-4 me-2 mb-2"
                onClick={() => {
                  window.location.reload();
                }}
              >
                ล้างค่า
              </button>
            </div>
          </div>
          <div className="d-flex mb-3">
            <button className="btn btn-warning px-4 me-2" onClick={() => this.ExportExcel()}>Export Excel</button>
            <button className="btn btn-warning px-4" onClick={() => this.ExportPDF()}>Export PDF</button>
          </div>
          </div>
          <div className="card rounded border-0 overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="bg-light text-secondary">
                  <tr>
                    <th className="text-start">ณ สิ้นสุดวันที่</th>
                    <th className="text-start">รายการ</th>
                    <th className="text-start">แยกประเภท</th>
                    <th className="text-end">ยอดเงิน</th>
                    <th className="text-start">link รูปภาพ</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={"table_" + index}>
                      <td>{format_date(item.date) || "-"}</td>
                      <td>{item.title || "-"}</td>
                      <td>
                        {data_expenses?.find(
                          (e) =>
                            e.expense_type_id === item.expenses_type_center,
                        )?.expense_type_name || "-"}
                      </td>
                      <td className="text-end">{toFixed(item.amount || 0) || "0.00"}</td>
                      <td>{item.image || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
